
import { useEffect } from 'react';

interface WechatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function WechatModal({ isOpen, onClose }: WechatModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-[340px] overflow-hidden animate-fade-in">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#07C160] to-[#0DAB52] px-6 py-5 text-white text-center relative">
          <button
            onClick={onClose}
            className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-base"></i>
          </button>
          <div className="w-10 h-10 flex items-center justify-center mx-auto mb-2">
            <i className="ri-wechat-line text-3xl text-white"></i>
          </div>
          <h3 className="text-base font-semibold">微信扫码咨询</h3>
          <p className="text-xs text-white/80 mt-1">添加企业微信，获取专属顾问服务</p>
        </div>

        {/* QR Code Area */}
        <div className="px-8 py-6 flex flex-col items-center">
          <div className="w-48 h-48 rounded-xl overflow-hidden border border-gray-100 shadow-sm mb-4">
            <img
              src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/19cca6571ebef100faaaee169f0d9063.png"
              alt="微信二维码"
              className="w-full h-full object-cover"
            />
          </div>

          <p className="text-sm font-medium text-gray-800 mb-1">扫码添加企业微信</p>
          <p className="text-xs text-gray-500 text-center leading-relaxed mb-5">
            专业顾问 1 对 1 解答<br />合规方案 · 价格咨询 · 技术对接
          </p>

          {/* Contact Info */}
          <div className="w-full space-y-2.5 border-t border-gray-100 pt-4">
            <a
              href="mailto:ceo@g4b.cn"
              className="flex items-center gap-3 text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer group"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-50 group-hover:bg-teal-50 transition-colors">
                <i className="ri-mail-line text-gray-400 group-hover:text-[#14B8A6] text-sm"></i>
              </span>
              ceo@g4b.cn
            </a>
            <a
              href="tel:+8613360027991"
              className="flex items-center gap-3 text-sm text-gray-600 hover:text-[#14B8A6] transition-colors cursor-pointer group"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-50 group-hover:bg-teal-50 transition-colors">
                <i className="ri-phone-line text-gray-400 group-hover:text-[#14B8A6] text-sm"></i>
              </span>
              13360027991
            </a>
            <div className="flex items-center gap-3 text-sm text-gray-400">
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-gray-50">
                <i className="ri-time-line text-gray-400 text-sm"></i>
              </span>
              工作日 09:00–18:00（节假日除外）
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
